import React from "react";
import { Stack, Typography } from "@mui/material";
import { formatInTimeZone } from "date-fns-tz";
import { formatTimeZoneToAbbreviation } from "utils/formatTimeZoneToAbbreviation";
import type { WorkingHoursSelectorSharedProps } from "./WorkingHoursSelector";

/**
 * Renders one working-hours row in its read-only format.
 */
export const WorkingHoursSelectorView = ({
  day,
  isActive,
  timeRanges,
  clinicianTimeZone,
}: WorkingHoursSelectorSharedProps) => {
  const dayLabel = `${day.charAt(0).toUpperCase() + day.slice(1)}`;
  const formatTime = (dateString: string) =>
    formatInTimeZone(new Date(dateString), clinicianTimeZone, "h:mm a");

  return (
    <Stack direction="row" gap="8px">
      <Typography variant="body.small" style={{ width: "79px" }}>
        {dayLabel}
      </Typography>
      {!isActive && (
        <Typography
          variant="subtitle2"
          style={{
            display: "flex",
            alignItems: "center",
            width: "128px",
            height: "20px",
          }}
        >
          Unavailable
        </Typography>
      )}
      {isActive && (
        <Stack gap="8px">
          {timeRanges.map((timeRange, index) => (
            <Stack key={index} flexDirection="row">
              <Typography
                variant="subtitle2"
                style={{
                  height: "20px",
                  display: "flex",
                  alignItems: "baseline",
                  minWidth: "128px",
                }}
              >
                {`${formatTime(timeRange.start)} to ${formatTime(
                  timeRange.end
                )} (${formatTimeZoneToAbbreviation(clinicianTimeZone)})`}
              </Typography>
            </Stack>
          ))}
        </Stack>
      )}
    </Stack>
  );
};
